module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-12-44df1b76538d5776c712fb647f000e96.svg";